import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetEmployerList = {
  getEmployerList: { data: null, loading: false, error: null },
};

export const getEmployerList = createAsyncThunk('user/getEmployerList', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/employers/`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetEmployerList = {
  [getEmployerList.pending]: (state) => {
    state.getEmployerList.data = null;
    state.getEmployerList.loading = true;
    state.getEmployerList.error = null;
  },
  [getEmployerList.fulfilled]: (state, action) => {
    state.getEmployerList.loading = false;
    state.getEmployerList.data = action.payload;
    state.getEmployerList.error = null;
  },
  [getEmployerList.rejected]: (state, action) => {
    state.getEmployerList.loading = false;
    state.getEmployerList.error = action.payload;
  },
};
